import { Injectable } from '@angular/core';
import { HttpHeaders, HttpResponse, HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private http: HttpClient) { }

  getHeaderJsonData(){
    return this.http.get<any>('/assets/column-data/headerNames.json');
  }

  public setUserGridSettings(payload): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ "Content-Type": "application/json" })
    };
    const apiURL = environment.getAPI("setUserGridSettings");
    return this.http.post<any>(apiURL, payload, httpOptions);
  }

  public getUserGridSettings(payload): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ "Content-Type": "application/json" })
    };
    const apiURL = environment.getAPI("getUserGridSettings");
    return this.http.post<any>(apiURL, payload, httpOptions);
  }
}
